
import React from "react";

function AcceptIcon() {
  return (
    <svg
  xmlns="http://www.w3.org/2000/svg"
  class="icon icon-tabler icon-tabler-checkbox"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  stroke-width="1.5"
  stroke="#fff"
  fill="none"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
  <path d="M9 11l3 3l8 -8"></path>
  <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9"></path>
</svg>
  );
}

export default AcceptIcon;
